/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
import type BvTabsTabComponent from 'volta/components/bv-tabs/tab';

interface BvTabsSignature {
  Args: {
    condensed?: boolean;
    expand?: boolean;
    isLoading?: boolean;
    onSelect?: (id: string) => void;
    selectedTab?: string;
  };
  Blocks: {
    default: [typeof BvTabsTabComponent];
    secondary: [typeof BvTabsTabComponent];
  };
  Element: HTMLDivElement;
}

const BvTabsComponent = templateOnlyComponent<BvTabsSignature>();

export default BvTabsComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    BvTabs: typeof BvTabsComponent;
    'bv-tabs': typeof BvTabsComponent;
  }
}
